import * as Sentry from '@sentry/nextjs'
import { useCustomerAddressesQuery } from '@/graphql/generated/hooks'
import { CustomerAddressesQuery } from '@/graphql/generated/operations'
import { CustomerTemplateAddressType } from '@/graphql/generated/schemas'
import { GraphQLAddressEdge } from '@/types/customer-template-address.type'

const filteredAddressList = (data: CustomerAddressesQuery | undefined): CustomerTemplateAddressType[] => {
  try {
    const result =
      data?.customerTemplateAddresses?.edges
        .filter(
          (edge): edge is GraphQLAddressEdge & { node: NonNullable<GraphQLAddressEdge['node']> } =>
            edge.node !== undefined && edge.node !== null
        )
        .map((edge) => edge.node) || []
    return result
  } catch (error) {
    Sentry.captureMessage('[배송지 정보] 배송지 정보 데이터 요청 실패')
    Sentry.captureException(error)
    return []
  }
}

export const useGetDeliveryAddressList = () => {
  const {
    data,
    loading: isAddressLoading,
    refetch,
  } = useCustomerAddressesQuery({
    variables: {
      orderBy: '-isDefault',
    },
  })

  const addressList = filteredAddressList(data)
  const defaultAddress = addressList.find((address: CustomerTemplateAddressType) => address.isDefault)

  return {
    addressList,
    defaultAddress,
    isAddressLoading,
    refetch,
  }
}
